import React, { useEffect, useState } from 'react';
import Loader from './components/Loader';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import WorksSection from './components/WorksSection';
import RecommendationsSection from './components/RecommendationsSection';
import BlogSection from './components/BlogSection';
import ConnectSection from './components/ConnectSection';
import CareerImpactPage from './components/CareerImpactPage';
import BlogIndexPage from './components/BlogIndexPage';
import BlogPostPage from './components/BlogPostPage';
import DraftReviewPage from './components/DraftReviewPage';
import ResumeReviewPage from './components/ResumeReviewPage';
import Seo from './components/Seo';
import { careerStoryBySlug } from './data/careerStories';
import { blogPostBySlug, blogPosts } from './generated/blogPosts';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const careerMatch = window.location.pathname.match(/^\/career\/([^/]+)\/?$/);
  const careerStory = careerMatch ? careerStoryBySlug[careerMatch[1]] : null;
  const blogMatch = window.location.pathname.match(/^\/blog\/([^/]+)\/?$/);
  const blogPost = blogMatch ? (blogPostBySlug[blogMatch[1]] || (import.meta.env.DEV ? blogPosts.find((post) => post.slug === blogMatch[1]) : null)) : null;
  const draftMatch = window.location.pathname.match(/^\/draft-review\/([^/]+)\/?$/);
  const draftPost = draftMatch ? blogPosts.find((post) => post.slug === draftMatch[1]) : null;

  useEffect(() => {
    if (isLoading || !window.location.hash) return;
    const target = document.querySelector(window.location.hash);
    if (!target) return;
    const frame = window.requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
      window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    });
    return () => window.cancelAnimationFrame(frame);
  }, [isLoading]);

  if (careerStory) {
    return <CareerImpactPage story={careerStory} />;
  }

  if (/^\/blog\/?$/.test(window.location.pathname)) {
    return <BlogIndexPage />;
  }

  if (blogPost) {
    return <BlogPostPage post={blogPost} />;
  }

  if (import.meta.env.DEV && /^\/draft-review\/?$/.test(window.location.pathname)) {
    return <DraftReviewPage />;
  }

  if (import.meta.env.DEV && /^\/resume-review\/?$/.test(window.location.pathname)) {
    return <ResumeReviewPage />;
  }

  if (import.meta.env.DEV && draftPost) {
    return <BlogPostPage post={draftPost} reviewMode />;
  }

  return (
    <div className="app-container bg-[#ffffff]">
      <Seo title="Katherine William-Botrous | Sales Leadership & Organizational Excellence" description="Katherine William-Botrous is a Vice President of Sales with senior leadership across client success, operations, and customer service — P&L ownership, high-performance teams, and contact-center excellence." />
      {isLoading ? <Loader onComplete={() => setIsLoading(false)} /> : <><HeroSection /><AboutSection /><WorksSection /><RecommendationsSection /><BlogSection /><ConnectSection /></>}
    </div>
  );
}
export default App;
